import { useEffect, useState } from 'react'
import BackgroundContext from './backgroundContext'

const STORAGE_KEY = 'show-background'

const getInitialBackground = () => {
	if (typeof window === 'undefined') return true

	const storedValue = window.localStorage.getItem(STORAGE_KEY)
	return storedValue === null ? true : storedValue === 'true'
}

const BackgroundState = (props) => {
	const [showBackground, setShowBackground] = useState(getInitialBackground)

	useEffect(() => {
		window.localStorage.setItem(STORAGE_KEY, String(showBackground))
	}, [showBackground])

	return (
		<BackgroundContext.Provider value={{ showBackground, setShowBackground }}>
			{props.children}
		</BackgroundContext.Provider>
	)
}

export default BackgroundState
